<script lang="ts">
  import type { DocLink } from "../types";

  export let doc: DocLink;

  function iconFor(url: string): string {
    if (/docs\.google\.com\/document/.test(url)) return "📄";
    if (/docs\.google\.com\/spreadsheets/.test(url)) return "📊";
    if (/docs\.google\.com\/presentation/.test(url)) return "🎞";
    if (/drive\.google\.com/.test(url)) return "📁";
    if (/notion\./.test(url)) return "📝";
    if (/loom\.com/.test(url)) return "🎥";
    if (/figma\.com/.test(url)) return "🎨";
    return "🔗";
  }

  function host(url: string): string {
    try {
      return new URL(url).hostname.replace(/^www\./, "");
    } catch {
      return "link";
    }
  }
</script>

<a
  href={doc.url}
  target="_blank"
  rel="noopener noreferrer"
  class="panel p-3 flex items-center gap-3 hover:border-border-strong transition-colors"
>
  <div class="text-2xl leading-none">{iconFor(doc.url)}</div>
  <div class="flex-1 min-w-0">
    <div class="text-sm font-medium text-text truncate">{doc.title}</div>
    <div class="text-xs text-text-dim truncate">{host(doc.url)} ↗</div>
  </div>
</a>
